'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _d = require('d3');

var _xAxis = require('./xAxis');

var _xAxis2 = _interopRequireDefault(_xAxis);

var _labels = require('./drawer/labels');

var _labels2 = _interopRequireDefault(_labels);

var _delimiters = require('./drawer/delimiters');

var _xAxis3 = require('./drawer/xAxis');

var _debounce = require('debounce');

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import * as d3 from 'd3/build/d3';
exports.default = function (container, dimensions, scales, configuration, data, callback) {
    var onZoom = function onZoom(data, index, element) {
        var scalingFunction = _d.event.transform.rescaleX(scales.x);
        var result = {};
        if ((0, _xAxis3.boolOrReturnValue)(configuration.hasTopAxis, data)) {
            container.selectAll('.x-axis.top').call((0, _d.axisTop)().scale(scalingFunction));
        }

        if ((0, _xAxis3.boolOrReturnValue)(configuration.hasBottomAxis, data)) {
            container.selectAll('.x-axis.bottom').call((0, _d.axisBottom)().scale(scalingFunction));
        }

        var sumDataCount = (0, _debounce2.default)(function (data, callback) {
            var domain = scalingFunction.domain();

            var result = {
                counts: (0, _labels2.default)(container.select('.labels'), { x: scalingFunction }, configuration)(data),
                dates: {
                    from: domain[0],
                    to: domain[1]
                }
            };

            (0, _delimiters.delimiters)(container, { x: scalingFunction }, configuration.leftWidth, configuration.dateFormat);
            if (callback) {
                callback(result);
            }
        }, 100);

        requestAnimationFrame(function () {
            container.selectAll('.drop-line').selectAll('.drop').attr('cx', function (d, i) {
                return scalingFunction(new Date(d.date));
            });

            container.selectAll('.shape-line').selectAll('.shape').attr('transform', function (d) {
                return 'translate(' + scalingFunction(configuration.date(d)) + ',' + configuration.shapes[d.shape].offsetY + ')';
            });

            sumDataCount(data, function (result) {
                if (callback) {
                    callback(result);
                }
            });
        });
    };

    var zoomEnd = function zoomEnd(data, index, element) {
        var scalingFunction = _d.event.transform.rescaleX(scales.x);
        var domain = scalingFunction.domain();
        configuration.zoomend({ dates: { from: domain[0], to: domain[1] } });
    };

    var zoomHandler = (0, _d.zoom)().scaleExtent([configuration.minScale, configuration.maxScale]).on('zoom', onZoom).on('end', zoomEnd);

    container.call(zoomHandler);
    return zoomHandler;
};
//# sourceMappingURL=zoom.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ansyn-event-drops/dist-es5/zoom.js
// module id = ../../../../ansyn-event-drops/dist-es5/zoom.js
// module chunks = vendor